"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Desktop = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Desktop = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M1 2h22a1 1 0 011 1v14a1 1 0 01-1 1h-8v2h1.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H9v-2H1a1 1 0 01-1-1V3a1 1 0 011-1zm1 14h20V4H2v12z", clipRule: "evenodd" })); };
exports.Desktop = Desktop;
//# sourceMappingURL=desktop.js.map